"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedFilterDataSelectorIds = void 0;
exports.AdvancedFilterDataSelectorIds = {
    menu: 'popover-menu',
    mainButton: 'advanced-filter-main-button',
    filterIcon: 'advanced-filter-icon',
    allButton: 'advanced-filter-all-button',
    noneButton: 'advanced-filter-none-button',
    checkbox: 'advanced-filter-checkbox',
    apply: 'advanced-filter-apply-button',
    cancel: 'advanced-filter-cancel-button'
};
//# sourceMappingURL=AdvancedFilterDataSelectorIds.js.map